import *  as TYPES from '../mutation-types'

export default {
  state: {
    user: {},
    isLogined: false
  },

  mutations: {
    [TYPES.LOGIN](state, {user}) {
      state.user = user;
      state.isLogined = true;
    },
  }
}



// WEBPACK FOOTER //
// ./src/stores/modules/user.js